import { ReactNode } from 'react';

import { useCurrentClassVar } from 'approot/classes/classes.hooks';
import SimpleModal from 'lib/modal/simple-modal';
import { useGetClassStudents } from 'approot/students/use-get-class-students';

type Props = {
  children: ReactNode;
  isStep1: boolean;
  onClose: () => void;
};

const AssignModalWrapper = ({ children, isStep1, onClose }: Props) => {
  const currentClass = useCurrentClassVar();
  const { hasStudents } = useGetClassStudents();

  const title = isStep1
    ? `Assign to ${currentClass?.name}`
    : hasStudents
      ? 'How Your Students Sign In'
      : 'How Your Class Sign In';

  return (
    <SimpleModal
      isVisible
      scrollWithinModal={isStep1}
      title={title}
      headerTitle={title}
      size={isStep1 ? 900 : 760}
      dataTrackingLabel="assign-activities"
      onClose={onClose}
      isOverflowable={!isStep1}
    >
      {children}
    </SimpleModal>
  );
};

export default AssignModalWrapper;
